import { aboutItem } from '@/mocks/homeData';

export default function About() {
  return (
    <section id="about" className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">{aboutItem.title}</h2>
          <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-2xl mx-auto">
            {aboutItem.description}
          </p>
        </div>
      </div>
    </section>
  );
}